import React, { useMemo } from 'react';
import { string, number, shape, bool } from 'prop-types';
import { getDaysPassedBetweenDates, getHumanisedTextFromNumberOfDays, hasDatePassed, getHumanisedNumber } from '@paddl/utils-js';
import { Duration, Meta, Placeholder } from './ActivityBadgeCard.styles';
import { ActivityColorPalette, badgesMetadata } from '../..';
import { ActivityBadgeHeader } from '../../Atoms/ActivityBadgeHeader';
import { Column } from '../../Organisms/Layouts/FoundationLayouts';
export const ActivityBadgeCard = _ref => {
  let {
    type,
    duration: {
      startDate = {},
      endDate = {},
      isCurrent
    },
    xpNumber,
    headlineElement,
    isLocked
  } = _ref;
  const {
    category
  } = badgesMetadata[type];
  const fontColour = ActivityColorPalette[category.toLowerCase()];
  const humanisedDuration = useMemo(() => {
    const newDate = new Date();
    const day = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    if (!!startDate && (!!endDate || isCurrent)) {
      const passedEndDate = new Date(endDate.year, endDate.month, endDate.day);
      const numberOfDays = getDaysPassedBetweenDates({
        endDate: isCurrent || !hasDatePassed(passedEndDate, new Date(year, month, day)) && isCurrent === undefined ? new Date(year, month, day) : passedEndDate,
        startDate: new Date(startDate.year, startDate.month, startDate.day)
      });
      return getHumanisedTextFromNumberOfDays(numberOfDays);
    }
    return '';
  }, [endDate, isCurrent, startDate]);
  return /*#__PURE__*/React.createElement(Column, {
    style: {
      gap: '24px'
    }
  }, /*#__PURE__*/React.createElement(ActivityBadgeHeader, {
    "data-test-id": "activity-badge-header",
    alignment: "center",
    type: type,
    headlineElement: headlineElement,
    isLocked: isLocked
  }), !isLocked ? /*#__PURE__*/React.createElement(Meta, {
    type: type,
    as: headlineElement
  }, humanisedDuration ? /*#__PURE__*/React.createElement(Duration, {
    "data-test-id": "activity-badge-duration"
  }, humanisedDuration) : null, xpNumber > 0 && /*#__PURE__*/React.createElement("span", {
    className: "xp-number",
    "data-test-id": "activity-badge-xp-number"
  }, getHumanisedNumber(xpNumber), /*#__PURE__*/React.createElement("small", null, "XP"))) : /*#__PURE__*/React.createElement(Placeholder, {
    style: {
      color: fontColour
    },
    "data-test-id": "activity-badge-header-placeholder"
  }, "Claim to unlock a Badge and gain XP"));
};
ActivityBadgeCard.propTypes = {
  type: string.isRequired,
  duration: shape({
    startDate: shape({
      day: number,
      month: number,
      year: number
    }),
    endDate: shape({
      day: number,
      month: number,
      year: number
    }),
    isCurrent: bool
  }),
  xpNumber: number,
  headlineElement: string,
  isLocked: bool
};
ActivityBadgeCard.defaultProps = {
  duration: {},
  xpNumber: 0,
  headlineElement: null,
  isLocked: false
};